var _path, _rect, _path2, _path3, _circle, _path4, _rect2, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInst1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 79,
    viewBox: "0 0 38 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.65 18.5C37.65 28.5152 29.309 36.65 19 36.65C8.69103 36.65 0.35 28.5152 0.35 18.5C0.35 8.48477 8.69103 0.35 19 0.35C29.309 0.35 37.65 8.48477 37.65 18.5Z",
    fill: "white",
    stroke: "#AC1E21",
    strokeWidth: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 8,
    height: 8,
    fill: "#005BA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9L33.1962 18H22.8038L28 9Z",
    fill: "url(#paint0_linear_52_2200)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21L19.3471 25.1459H23.7063L20.1796 27.7082L21.5267 31.8541L18 29.2918L14.4733 31.8541L15.8204 27.7082L12.2937 25.1459H16.6529L18 21Z",
    fill: "#C77F7A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 60.5,
    r: 18.15,
    fill: "white",
    stroke: "#AC1E21",
    strokeWidth: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 55L15.1962 64H4.80385L10 55Z",
    fill: "url(#paint1_linear_52_2200)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 51,
    width: 13,
    height: 3,
    fill: "#AC1E21"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 65,
    r: 5,
    fill: "#077E50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_52_2200",
    x1: 31.8434,
    y1: 19.3687,
    x2: 34.2284,
    y2: 6.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAC49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_52_2200",
    x1: 13.8434,
    y1: 65.3687,
    x2: 16.2284,
    y2: 52.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCAC49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst1);
export default __webpack_public_path__ + "static/media/inst1.6a58a77b84a0579afdf9e7693a0a5fd9.svg";
export { ForwardRef as ReactComponent };